<template>
  <settings-checker>
    <div class="booking">
      <div class="booking-wrapper">
        <petstar-ribbon/>
        <div class="booking-divider booking-divider-left">
          <div class="booking-content">
            <booking-header/>
            <div class="w-100 d-block d-md-none px-4 mb-3">
              <home-button/>
            </div>
            <template v-if="[0,1,4,5].includes(tab)">
              <opening-hours v-if="availableResourceOpenSlots.length === 0"/>
              <open-slot-list v-if="[0,1].includes(tab) && availableResourceOpenSlots.length > 0" :slots="availableResourceOpenSlots" :resources="resources"/>
            </template>
            <template v-else>
              <div class="section-header d-flex">Booking Summary</div>
              <summary-client/>
              <booking-summary v-if="tab !== 2"/>
            </template>
          </div>
          <div class="fixed-buttons d-none d-md-block">
            <home-button/>
          </div>
        </div>
        <anonymous-booking-disabled v-if="!clientTypeAllowed || !subscriptionFeatureAllowed"/>
        <template v-else>
          <idle @idle="handleIdle"/>
          <site-booking-setting-set/>
          <appointment-defaults-set
            :service-based-duration-enabled="siteBookingSettingServiceBasedDurationEnabled"
            :service-select-enabled="siteBookingSettingServiceSelectEnabled"/>
          <client-details v-if="tab === 0" @next="handleNext"/>
          <client-address v-if="tab === 1" @next="handleNext" @back="handleBack"/>
          <new-pets v-if="tab === 2" @next="handleNext" @back="handleBack" @toLastPet="handleToLastPet"/>
          <products-select v-if="tab === 3" @next="handleNext" @back="handleBack" :last-pet="lastPet"/>
          <date-time-select v-if="tab === 4" @next="handleNext" @back="handleBack" @toLastPet="handleToLastPet" :resource-time-slots-enabled="siteBookingSettingResourceTimeSlotsEnabled"/>
          <booking-confirmation v-if="tab === 5" @back="handleBack"/>
        </template>
      </div>
    </div>
  </settings-checker>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { SelectedSiteIdMixin } from '@/mixins/Booking/SelectedSiteIdMixin'
import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin'
import { SubscriptionCacheMixin } from '@/mixins/Booking/SubscriptionCacheMixin'
import { OpenSlotCacheMixin } from '@/mixins/Booking/OpenSlotCacheMixin'
import OpenSlotList from './OpenSlotList.vue'
import Header from './Header.vue'
import OpeningHours from './OpeningHours.vue'
import PetstarRibbon from './PetstarRibbon.vue'
import ClientDetails from './Anonymous/ClientDetails.vue'
import ClientAddress from './Anonymous/ClientAddress.vue'
import NewPets from './PetDetails/NewPets.vue'
import ProductsSelect from './ProductsSelect.vue'
import DateTimeSelect from './TimeSlots/DateTimeSelect.vue'
import SettingsChecker from './SettingsChecker.vue'
import Confirmation from './Confirmation.vue'
import Summary from './Summary.vue'
import SummaryClientDetails from './Anonymous/SummaryClientDetails.vue'
import AppointmentDefaultsSet from './AppointmentDefaultsSet.vue'
import SiteBookingSettingSet from './SiteBookingSettingSet.vue'
import AnonymousBookingDisabled from './Anonymous/AnonymousBookingDisabled.vue'
import HomeButton from './HomeButton.vue'
import Idle from './Idle.vue'

export default {
  name: 'Anonymous',
  mixins: [SelectedSiteIdMixin, SiteBookingSettingMixin, SubscriptionCacheMixin, OpenSlotCacheMixin],
  data () {
    return {
      tab: 0,
      lastPet: false
    }
  },
  computed: {
    ...mapState('BookingUpload', [
      'openSlotBooking'
    ]),
    clientTypeAllowed () {
      return this.siteBookingSettingClientType === 2
    },
    featureKey () {
      return 'unregisteredClientBookingAllowed'
    }
  },
  methods: {
    ...mapMutations('BookingUpload', [
      'resetBookingUpload'
    ]),
    ...mapActions('Authentication', [
      'logout'
    ]),
    handleNext () {
      if (!this.siteBookingSettingUnregisteredClientAddressRequired && this.tab === 0) { // client-details: skip address
        this.tab = 2
      } else if (!this.siteBookingSettingServiceSelectEnabled && this.tab === 2) { // new-pets: skip products
        if (this.openSlotBooking) { // also skip date-time
          this.applyOpenSlotData()
          this.tab = 5
        } else {
          this.tab = 4
        }
      } else if (this.openSlotBooking && this.tab === 3) { // products: skip date-time
        this.applyOpenSlotData()
        this.tab = 5
      } else {
        this.tab++
      }
    },
    handleBack () {
      if (this.openSlotBooking && this.tab === 5) { // confirm: skip date-time
        this.tab = this.siteBookingSettingServiceSelectEnabled ? 3 : 2
      } else if (!this.siteBookingSettingUnregisteredClientAddressRequired && this.tab === 2) { // new-pets: skip address
        this.tab = 0
      } else if (!this.siteBookingSettingServiceSelectEnabled && this.tab === 4) { // date-time: skip products
        this.tab = 2
      } else {
        this.tab--
      }
    },
    handleToLastPet (value) {
      this.lastPet = !!value
    },
    handleIdle () {
      this.$router.push({ name: 'bookingHome', query: { siteId: this.selectedSiteId } })
        .then(() => { window.location.reload() })
    }
  },
  created () {
    this.resetBookingUpload()
    this.logout()
  },
  components: {
    'booking-header': Header,
    'settings-checker': SettingsChecker,
    'petstar-ribbon': PetstarRibbon,
    'opening-hours': OpeningHours,
    'open-slot-list': OpenSlotList,
    'client-details': ClientDetails,
    'client-address': ClientAddress,
    'new-pets': NewPets,
    'products-select': ProductsSelect,
    'date-time-select': DateTimeSelect,
    'booking-confirmation': Confirmation,
    'summary-client': SummaryClientDetails,
    'booking-summary': Summary,
    'site-booking-setting-set': SiteBookingSettingSet,
    'appointment-defaults-set': AppointmentDefaultsSet,
    'anonymous-booking-disabled': AnonymousBookingDisabled,
    'home-button': HomeButton,
    idle: Idle
  }
}
</script>
